import React from "react";
import { Oval } from "react-loader-spinner";

const Loader = ({ size = 20, color = "#ffffff", secondaryColor = "#ffffff" }) => {
  return (
    <Oval
      height={size}
      width={size}
      color={color}
      secondaryColor={secondaryColor}
      ariaLabel="loading"
      wrapperStyle={{}}
      wrapperClass=""
      visible={true}
    />
  );
};

export default Loader;